import { ApiTypes } from 'common';
import { queryClient, QUERY_KEYS } from '@src/query';
import { getUserConfig } from './api';
import { getDefaultStore } from 'jotai';
import { userAtom } from '@src/state/userAtom';

const jotaiStore = getDefaultStore();

/**
 * Fetch user config from the server, populate react-query cache and userAtom.
 */
export async function loadUserInfo(): Promise<ApiTypes.ResGetMe> {
  const data = await queryClient.fetchQuery({ queryKey: QUERY_KEYS.userConfig(), queryFn: getUserConfig });
  if (data?.user) {
    jotaiStore.set(userAtom, data.user);
  }
  return data;
}
